import { create } from 'zustand';

import type { MeResponse } from '@/lib/api/auth';

/**
 * Social-login (v2-auth) session state.
 *
 * `me` is the canonical session from `GET /v2/auth/me` (or seeded from the OAuth
 * callback). It is null until the first fetch resolves; `{ authenticated:false }`
 * once we know the user is logged out. The actual identity lives in an HttpOnly
 * cookie the browser holds — this store only mirrors the readable projection.
 */
interface OAuthSessionState {
    me: MeResponse | null;
    /** A login/logout request is in flight (drives button spinners). */
    isLoading: boolean;
    /** The one-time hydration (GET /v2/auth/me) has been kicked off. */
    initialized: boolean;
    setMe: (me: MeResponse | null) => void;
    setLoading: (loading: boolean) => void;
    setInitialized: (initialized: boolean) => void;
}

export const useOAuthStore = create<OAuthSessionState>((set) => ({
    me: null,
    isLoading: false,
    initialized: false,
    setMe: (me) => set({ me }),
    setLoading: (isLoading) => set({ isLoading }),
    setInitialized: (initialized) => set({ initialized }),
}));
